import { render } from "./napOrder.vue?vue&type=template&id=13a302f2&scoped=true"
import script from "./napOrder.vue?vue&type=script&lang=js"
export * from "./napOrder.vue?vue&type=script&lang=js"

import "./napOrder.vue?vue&type=style&index=0&id=13a302f2&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk2.muugame.com\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13a302f2"]])

export default __exports__